import { memoize } from "lodash";
import { IdProfilePicture } from "../constants/IdProfilePicture";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingPictures = function () { return utilBalancing.getBalancing().ProfilePictures; };
export var selectPlayerProfileBalancing = memoize(function (pictureId) {
    return selectBalancingPictures().get(pictureId);
});
export var selectPlayerProfilePictureName = memoize(function (pictureId) {
    var playerProfileFromBalancing = selectPlayerProfileBalancing(pictureId);
    if (playerProfileFromBalancing == undefined) {
        var defaultProfile = selectPlayerProfileBalancing(IdProfilePicture.Default);
        return defaultProfile.assetName;
    }
    return playerProfileFromBalancing.assetName;
});
export var balancingPicturesMemoizedFunctions = [
    selectBalancingPictures,
    selectPlayerProfileBalancing,
    selectPlayerProfilePictureName,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingPictures.ts
// module id = 123
// module chunks = 3